<template>
  <div class="w-full flex flex-col">
    <div
      class="wrap-delivery w-full grid-cols-1 tb:grid-cols-3 sm:grid-cols-2 gap-4 grid"
    >
      <div
        class="deliveryItem w-full px-25 py-23 shadow-custom rounded-xl border border-bcolor"
        v-for="(deliveryItem, index) in deliveryItems"
        :key="index"
      >
        <div class="title mb-3">
          {{ deliveryItem.NAME }}
        </div>
        <div
          class="mb-3"
          v-for="(delivery, indexDelivery) in deliveryItem.ITEMS.filter(
            (el) => el.ID !== 'I_PICKUP'
          ).slice(0, 1)"
          :key="delivery.ID"
        >
          <div v-if="delivery.ID != 'I_PICKUP' && indexDelivery < 1">
            <div class="flex justify-between items-center">
              <div class="delyveryName w-3/4 mb-1">
                {{ delivery.NAME }}
              </div>
              <div class="delyveryTransit">
                {{ delivery.TRANSIT }}
              </div>
            </div>
            <div
              class="flex justify-between items-center"
              v-if="!delivery.condition && !delivery.free"
            >
              <div class="condition">
                {{ lang.to }} {{ delivery.FREE_DELIVERY }} {{ lang.currency }}
              </div>
              <div class="delyveryPrice">
                {{ delivery.PRICE_RULE }} {{ lang.currency }}
              </div>
            </div>
            <div
              class="flex justify-between items-center"
              v-if="delivery.condition"
            >
              <div class="condition">
                {{ lang.to }} {{ delivery.conditionFirst }} {{ lang.currency }}
              </div>
              <div class="delyveryPrice">
                {{ delivery.priceFirst }} {{ lang.currency }}
              </div>
            </div>
            <div
              class="flex justify-between items-center"
              v-if="delivery.condition"
            >
              <div class="condition">
                {{ lang.from }} {{ delivery.conditionFirst }}
                {{ lang.currency }} {{ lang.to }} {{ delivery.FREE_DELIVERY }}
                {{ lang.currency }}
              </div>
              <div class="delyveryPrice">
                {{ delivery.priceSecond }} {{ lang.currency }}
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="condition" v-if="!delivery.free">
                {{ lang.from }} {{ delivery.FREE_DELIVERY }} {{ lang.currency }}
              </div>
              <div class="delyveryPrice">
                {{ lang.free }}
              </div>
            </div>
          </div>
        </div>
        <a
          href=""
          class="spoilerButton"
          v-if="deliveryItem.ITEMSCOUNT != 1 && !spoiler[index]"
          @click.prevent="showItem(index)"
          >{{ lang.show }} {{ deliveryItem.ITEMSCOUNT - 1 }}</a
        >
        <div class="hideItem" v-if="spoiler[index]">
          <div
            class="mb-4"
            v-for="(delivery, indexDelivery) in deliveryItem.ITEMS"
            :key="delivery.ID"
          >
            <div v-if="delivery.ID != 'I_PICKUP' && indexDelivery > 0">
              <div class="flex justify-between items-center">
                <div class="delyveryName w-3/4 text-lg">
                  {{ delivery.NAME }}
                </div>
                <div class="delyveryTransit">
                  {{ delivery.TRANSIT }}
                </div>
              </div>
              <div
                class="flex justify-between items-center"
                v-if="!delivery.condition && !delivery.free"
              >
                <div class="condition">
                  {{ lang.to }} {{ delivery.FREE_DELIVERY }} {{ lang.currency }}
                </div>
                <div class="delyveryPrice">
                  {{ delivery.PRICE_RULE }} {{ lang.currency }}
                </div>
              </div>
              <div
                class="flex justify-between items-center"
                v-if="delivery.condition"
              >
                <div class="condition">
                  {{ lang.to }} {{ delivery.conditionFirst }}
                  {{ lang.currency }}
                </div>
                <div class="delyveryPrice">
                  {{ delivery.priceFirst }} {{ lang.currency }}
                </div>
              </div>
              <div
                class="flex justify-between items-center"
                v-if="delivery.condition"
              >
                <div class="condition">
                  {{ lang.from }} {{ delivery.conditionFirst }}
                  {{ lang.currency }} {{ lang.to }}
                  {{ delivery.FREE_DELIVERY }} {{ lang.currency }}
                </div>
                <div class="delyveryPrice">
                  {{ delivery.priceSecond }} {{ lang.currency }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="condition" v-if="!delivery.free">
                  {{ lang.from }} {{ delivery.FREE_DELIVERY }}
                  {{ lang.currency }}
                </div>
                <div class="delyveryPrice">
                  {{ lang.free }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          href=""
          class="spoilerButton"
          v-if="deliveryItem.ITEMSCOUNT != 1 && spoiler[index]"
          @click.prevent="showItem(index)"
          >{{ lang.hide }}</a
        >
        <div class="pt-6" v-if="index === 2"></div>
      </div>
      <IPickup :lang="lang" :itemClass="countItemsClass" v-if="pickup" />
    </div>
  </div>
</template>

<script>
import IPickup from "@/components/IPickup.vue";

export default {
  name: "DeliveryInfo",
  components: {
    IPickup,
  },
  props: {
    deliveryItems: Array,
    lang: [],
    pickup: Boolean,
    countItemsClass: String,
  },
  data() {
    return {
      spoiler: {
        0: false,
        1: false,
        2: false,
      },
    };
  },
  methods: {
    showItem(i) {
      this.spoiler[i] = !this.spoiler[i];
    },
  },
};
</script>

<style scoped>
.delyveryTransit {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  color: rgba(51, 63, 72, 0.75);
}

#app .deliveryItem .title {
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
}

#app .deliveryItem .delyveryName {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

#app .deliveryItem .condition {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

#app .deliveryItem .delyveryPrice {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-transform: lowercase;
}

.spoilerButton {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #fa5f55;
}
</style>
